module.exports = __webpack_public_path__ + "static/media/gw.7ffcfa41.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/gw.svg
// module id = 138
// module chunks = 0